import './FundCriteriaDetailList.css';
import '../../../Common/typography.css';
import { FundCriteria, FundCriteriaSetter } from '../../../../types/fundScreener.type';
import FundCriteriaSetting from '../FundCriteriaSetting/FundCriteriaSetting';

export interface FundCriteriaDetailListProps {
  market: string;
  tempCriteria: FundCriteria[];
  selectedCriteria: FundCriteria[];
  setCriteria: FundCriteriaSetter;
  token: string;
}

const FundCriteriaDetailList = ({
  market,
  tempCriteria,
  selectedCriteria,
  setCriteria,
  token,
}: FundCriteriaDetailListProps) => {
  return (
    <div className="fund-criteria-detail-list">
      {selectedCriteria.length > 0 ? (
        selectedCriteria.map((item) => (
          <FundCriteriaSetting
            key={item.id}
            market={market}
            tempCriteria={tempCriteria}
            criteria={item}
            setCriteria={setCriteria}
            token={token}
          />
        ))
      ) : (
        <div className="fund-criteria-detail-list-empty body-s-regular">
          No criteria selected
        </div>
      )}
    </div>
  );
};

export default FundCriteriaDetailList;
